<template>
  <div class="">
    <div v-if="label != null" class="overflow-hidden">
      <div class="float-left label-standard">
        <RequiredAsterisk v-if="required"></RequiredAsterisk>
        {{ label }}
      </div>

      
      <div v-if="tooltip != null" class="float-left ml-4" style="margin-top:1px;">
        <div class="" v-tooltip.top="{ html: propertyKey + 'Tooltip' }">
          <img src="/static/img/icons/icons8-info-grey.png" style="width:13px;height:13px;" />
        </div>

        <div :id="propertyKey + 'Tooltip'" class="p-1">{{ tooltip }}</div>
      </div>
    </div>

    <div :class="{ relative : true, 'form-line' : label != null }">
      <input type="text"
        class="input-standard"
        ref="value"
        v-model="localValue"
        v-on:blur="inputBlurred($event.target.value)"
        v-on:keyup="validate($event.target.value)" />
    </div>

    <div v-if="error" class="mt-2 text-red-600">{{ error }}</div>
  </div>
</template>

<script>
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },
      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      required : {
        type : Boolean,
        required : false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },

    watch: {
      value : {
        
        deep     : true,
        immediate: true,

        handler(newValue, oldValue) {
          this.localValue = newValue
        },

      },
    },

    data() {
      return {
        localValue: this.value,
        error     : null,
      }
    },

    methods : {

      validate(value) {
        if(value != null && value.length > 0 && parseInt(value).toString() != value) {
          this.error = "Invalid postcode"
        } else {
          this.error = null
        }
      },

      inputBlurred(value) {
        if(this.error == null) {
          this.updateValue({
            objectType: this.objectType,
            objectId  : this.objectId,
            index     : this.index,
            key       : this.propertyKey,
            value     : value
          })
        }
      },
    }
  }
</script>